import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import * as $ from 'jquery';
import { OrderPipe } from 'ngx-order-pipe';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
    selector: 'app-notice-board',
    templateUrl: './notice-board.component.html',
    styleUrls: ['./notice-board.component.scss']
})
/** notice-board component*/
export class NoticeBoardComponent {
  /** News ctor */
  notice: any;
  route: any;
  fileUrl: any;
  title: any;
  itemsPerPage: number;
  Search: any;
  paginationPageNumber: number;
  noticeCount: any;
  noticetitle: any;
  content: any;
  currentDate: any = new Date();
  MenuList: any;
  multipleEntry: boolean = false;
  imgUrl: any;
  noticeBoardSpinner: boolean;
  constructor(private spinner: NgxSpinnerService,private appComponent: AppComponent, private http: HttpClient, private router: Router, private datePipe: DatePipe, private orderPipe: OrderPipe) {
    this.imgUrl = window["orginalImgUrl"];
    this.fileUrl = window["getfile"];
    var str = this.router.url;
    this.route = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
  }
  ngOnInit() {
    this.spinner.show();
    this.paginationPageNumber = 1;
    this.itemsPerPage = 5;
    this.getMenuName();
    this.getNotice();
    
  }

  search() {
    this.paginationPageNumber = 1;
  }

  getMenuName() {
    var id = 49;
    this.http.get(this.appComponent.APIUrl + 'MenuMaster/', {
    }).subscribe((data: any) => {
      this.MenuList = data.menuMasterDTO.filter(x => x.link == this.route);
      this.multipleEntry = this.MenuList[0].multipleEntry;
      this.title = this.MenuList[0].title;
    });
  }
  getNotice() {
    this.noticeBoardSpinner = true;
    this.http.get(this.appComponent.APIUrl + 'Post/GetPostByRoute/' + this.route, {
    }).subscribe((data: any) => {
      this.noticeBoardSpinner = false;
      this.notice = data.postDTO.filter(x => x.status == 'Active' && x.displayonhome == 1);
      this.noticeCount = this.notice.length;
      this.currentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd' + 'T00:00:00');
    });
  }

  itemPerPagePagination(event: any) {
    this.itemsPerPage = event.target.value;
  }
}
